module["exports"] = [
  "zu",
  "von",
  "vom",
  "von der"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/de/name/nobility_title_prefix.js
// module id = 1971
// module chunks = 2